import * as lang from "./mscript-lang.js";

export const NODE_QUERY = 'query';
export const NODE_FILTER = 'filter';
export const NODE_ORDER = 'order';
export const NODE_OFFSET = 'offset';
export const NODE_LIMIT = 'limit';
export const NODE_LITERAL = 'literal';
export const NODE_IDENT = 'ident';
export const NODE_VAR = 'var';
export const NODE_FUNC_CALL = 'func-call';
export const NODE_UN_OP = 'un-op';
export const NODE_BIN_OP = 'bin-op';
export const NODE_TERN_OP = 'tern-op';
export const NODE_ORDERBY = 'order-by';

export function query(filter = null, order = null, limit = null, offset = null) {
    return {
        nodetype: NODE_QUERY,
        filter,
        order,
        limit,
        offset,
    };
}

export function order(ident, desc = false) {
    return {
        nodetype: NODE_ORDER,
        ident,
        direction: desc ? 'desc' : 'asc',
    };
}

export function op(nodetype, operator, args) {
    return {
        nodetype,
        op: operator,
        args,
    };
}

export function unop(operator, expr) {
    return op(NODE_UN_OP, operator, [expr]);
}

export function binop(operator, left, right) {
    return op(NODE_BIN_OP, operator, [left, right]);
}

export function funccall(name, args) {
    return {
        nodetype: NODE_FUNC_CALL,
        name,
        args: args || [],
    };
}

export function ident(name) {
    return {
        nodetype: NODE_IDENT,
        name,
    };
}

export function variable(name) {
    return {
        nodetype: NODE_VAR,
        name,
    };
}

export function literal(type, value) {
    return {
        nodetype: NODE_LITERAL,
        type,
        value,
    };
}

export function intnum(value) {
    return literal(lang.TYPE_INT, value);
}

export function floatnum(value) {
    return literal(lang.TYPE_FLOAT, value);
}

export function string(value) {
    return literal(lang.TYPE_STRING, value);
}

export function bool(value) {
    return literal(lang.TYPE_BOOL, value);
}

export function nullLiteral() {
    return literal(lang.TYPE_NULL, null);
}

export function symbol(name) {
    return literal(lang.TYPE_SYMBOL, name);
}

export function datetime(date, time, zone) {

    let type = null;

    if (zone === null || zone === '') {
        if (date !== null && time !== null) {
            type = lang.TYPE_LOCAL_DATETIME;
        } else if (date !== null) {
            type = lang.TYPE_LOCAL_DATE;
        } else if (time !== null) {
            type = lang.TYPE_LOCAL_TIME;
        } else {
            type = lang.TYPE_LOCAL_DATETIME;
        }
    } else if (time === null) {
        if (date !== null)
            type = lang.TYPE_LOCAL_DATE;
        else if (time !== null)
            type = lang.TYPE_LOCAL_TIME;
        else
            type = lang.TYPE_LOCAL_DATETIME;
    } else {
        type = zone === 'Z' ? lang.TYPE_UTC_DATETIME : lang.TYPE_ZONED_DATETIME;
    }

    let iso = '';
    if (date !== null)
        iso = date;
    if (time !== null)
        iso += (iso !== '' ? 'T' : '') + time;
    if (zone !== null && zone !== '' && time !== null)
        iso += zone;

    return {
        nodetype: NODE_LITERAL,
        type,
        value: {
            date,
            time,
            zone: zone === '' ? null : zone,
            iso,
        },
    };
}
